/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProviderImmunizationList } from '../models/PaginatedProviderImmunizationList';
import type { PatchedProviderImmunizationWrite } from '../models/PatchedProviderImmunizationWrite';
import type { ProviderImmunization } from '../models/ProviderImmunization';
import type { ProviderImmunizationWrite } from '../models/ProviderImmunizationWrite';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProviderImmunizationsService {

    /**
     * @returns PaginatedProviderImmunizationList
     * @throws ApiError
     */
    public static providerImmunizationsList({
        limit,
        offset,
        provider,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        provider?: string,
    }): CancelablePromise<PaginatedProviderImmunizationList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-immunizations/',
            query: {
                'limit': limit,
                'offset': offset,
                'provider': provider,
            },
        });
    }

    /**
     * @returns ProviderImmunization
     * @throws ApiError
     */
    public static providerImmunizationsCreate({
        requestBody,
    }: {
        requestBody: ProviderImmunizationWrite,
    }): CancelablePromise<ProviderImmunization> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/provider-immunizations/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderImmunization
     * @throws ApiError
     */
    public static providerImmunizationsRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this immunization.
         */
        id: string,
    }): CancelablePromise<ProviderImmunization> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-immunizations/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProviderImmunization
     * @throws ApiError
     */
    public static providerImmunizationsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this immunization.
         */
        id: string,
        requestBody?: PatchedProviderImmunizationWrite,
    }): CancelablePromise<ProviderImmunization> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/provider-immunizations/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static providerImmunizationsDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this immunization.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/provider-immunizations/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
